import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import {setCurrency} from "../../store/slices/currency-slice";
import {useDispatch, useSelector} from "react-redux";

const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
  const { t } = useTranslation();
  const {i18n} = useTranslation();
  const dispatch = useDispatch();

  const currency = useSelector((state) => state.currency);

  const changeLanguageTrigger = e => {
    const languageCode = e.target.value;
    i18n.changeLanguage(languageCode);
    window.location = '/shop';
  };

  const setCurrencyTrigger = e => {
    const currencyName = e.target.value;
    dispatch(setCurrency(currencyName));
  };

  return (
    <div
      className={clsx(sidebarMenu
          ? "sidebar-menu"
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`)}
    >
      <nav>
        <ul>
          <li>
            <Link to={process.env.PUBLIC_URL + "/"}>
              {t("home")}
            </Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + "/contact"}>
              {t("contact_us")}
            </Link>
          </li>
          <li>
            <div className="language-currency-wrap">
              <div className="same-language-currency language-style">
        <span style={{color: 'white'}}>
          {i18n.resolvedLanguage === "en"
              ? "English"
              : i18n.resolvedLanguage === "fr"
                  ? "French"
                  : i18n.resolvedLanguage === "de"
                      ? "Deutsch"
                      : i18n.resolvedLanguage === "sv"
                          ? "Swedish"
                          : i18n.resolvedLanguage === "fi"
                              ? "Finnish"
                              : i18n.resolvedLanguage === "nl"
                                  ? "Dutch"
                                  : i18n.resolvedLanguage === "dk"
                                      ? "Danish"
                                      : i18n.resolvedLanguage === "es"
                                          ? "Spanish"
                                      : i18n.resolvedLanguage === "no"
                                          ? "Norwegian"
                            : ""}{" "}
          <i className="fa fa-angle-down" style={{color: 'white'}}/>
        </span>
                <div className="lang-car-dropdown">
                  <ul>
                    <li>
                      <button value="en" onClick={e => changeLanguageTrigger(e)}>
                        English
                      </button>
                    </li>
                    <li>
                      <button value="fr" onClick={e => changeLanguageTrigger(e)}>
                        French
                      </button>
                    </li>
                    <li>
                      <button value="de" onClick={e => changeLanguageTrigger(e)}>
                        Deutsch
                      </button>
                    </li>
                    <li>
                      <button value="sv" onClick={e => changeLanguageTrigger(e)}>
                        Swedish
                      </button>
                    </li>
                    <li>
                      <button value="es" onClick={e => changeLanguageTrigger(e)}>
                       Spanish
                      </button>
                    </li>
                    <li>
                      <button value="fi" onClick={e => changeLanguageTrigger(e)}>
                        Finnish
                      </button>
                    </li>
                    <li>
                      <button value="nl" onClick={e => changeLanguageTrigger(e)}>
                        Dutch
                      </button>
                    </li>
                    <li>
                      <button value="dk" onClick={e => changeLanguageTrigger(e)}>
                        Danish
                      </button>
                    </li>
                    <li>
                      <button value="no" onClick={e => changeLanguageTrigger(e)}>
                        Norwegian
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="language-currency-wrap">
              <div className="same-language-currency use-style">
                <span style={{color: 'white'}}>
                  {currency.currencyName} <i className="fa fa-angle-down" style={{color: 'white'}}/>
                </span>
                <div className="lang-car-dropdown">
                  <ul>
                    <li style={{width: "100%"}}>
                      <button value="USD" onClick={e => setCurrencyTrigger(e)}>
                        USD
                      </button>
                    </li>
                    <li style={{width: "100%"}}>
                      <button value="EUR" onClick={e => setCurrencyTrigger(e)}>
                        EUR
                      </button>
                    </li>
                    <li style={{width: "100%"}}>
                      <button value="GBP" onClick={e => setCurrencyTrigger(e)}>
                        GBP
                      </button>
                    </li>
                    <li style={{width: "100%"}}>
                      <button value="SEK" onClick={e => setCurrencyTrigger(e)}>
                        SEK
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;
